'use strict';

var vehicleApp = function () {
  var currentVehicle = void 0,
      currentPrices = void 0,
      currentArea = void 0;
  var domNodes = {
    modelName: { $new: $('.js-model-new'), $name: $('.js-model-name') },
    $motor: $('.js-motor'),
    $transmissionTraction: $('.js-transmission-traction'),
    $color: $('.js-color'),
    $colorType: $('.js-color-type'),
    $versionName: $('.js-version-name'),
    $legalNotes: $('.js-legal-notes'),
    $priceArea: $('.js-price-area'),
    $pvpPrice: $('.js-pvp-price'),
    $offerPrice: $('.js-offer-price')
  };
  var _setCurrentVehicle = function _setCurrentVehicle(value) {
    return currentVehicle = value;
  },
      _getCurrentVehicle = function _getCurrentVehicle() {
    return currentVehicle;
  };
  var _setCurrentPrices = function _setCurrentPrices(value) {
    return currentPrices = value;
  },
      _getCurrentPrices = function _getCurrentPrices() {
    return currentPrices;
  };
  var _setCurrentArea = function _setCurrentArea(value) {
    return currentArea = value;
  },
      _getCurrentArea = function _getCurrentArea() {
    return currentArea;
  };
  var _getCompleteName = function _getCompleteName(name) {
    return utils.getDisplayModelName(name).completeName;
  };

  var _printTitle = function _printTitle(modelname) {
    document.title = _getCompleteName(modelname) + ' ' + _getCurrentVehicle().vgrado.toUpperCase() + ' ' + _getCurrentVehicle().vcolor + ' | Nissan Nuevo en Stock (' + utils.getDisplayAreaName(_getCurrentArea()) + ')';
  };

  var _addMetaDescription = function _addMetaDescription(area) {
    var vehicle = _getCurrentVehicle();
    var areaDisplayName = utils.getDisplayAreaName(area);
    var metaContent = vehicle.vdisplayModelo.toUpperCase().replace('E-', 'e-') + ' ' + vehicle.vgrado + ' ' + vehicle.vcolor + ' | Encuentra tu pr\xF3ximo Nissan ' + vehicle.vdisplayModelo + ' ' + vehicle.vgrado + ' nuevo en stock y disponible ahora en ' + areaDisplayName + '. Tu nuevo Nissan ' + vehicle.vdisplayModelo + ' ' + vehicle.vgrado + ' te est\xE1 esperando.';
    var metaTag = document.createElement('meta');
    metaTag.setAttribute('name', 'description');
    metaTag.setAttribute('content', metaContent);
    document.head.appendChild(metaTag);
  };

  var _printBreadCrum = function _printBreadCrum(modelname) {
    var path = window.location.pathname.split('/');
    var modelUrl = '';
    for (var a = 0; a < path.length - 1; a++) {
      if (a > 0) modelUrl += '/';
      modelUrl += path[a];
    }
    $('.js-prev').text(_getCompleteName(modelname)).attr('href', modelUrl);
    $('.js-page').text(_getCompleteName(modelname) + ' ' + _getCurrentVehicle().vgrado);
  };

  var _displayGeneralData = function _displayGeneralData() {
    var vehicle = _getCurrentVehicle(),
        prices = _getCurrentPrices();

    var displayModelName = utils.getDisplayModelName(vehicle.vdisplayModelo);
    if (displayModelName.hasOwnProperty('new')) {
      domNodes.modelName.$new.text(displayModelName.new).removeClass('hidden');
    }
    domNodes.modelName.$name.text(displayModelName.name);
    domNodes.$versionName.text(vehicle.vgrado.toUpperCase().replace('E+', 'e+'));
    domNodes.$motor.text(vehicle.vmotor);
    domNodes.$transmissionTraction.text(vehicle.vtransmision + ' / ' + vehicle.vtraccion);
    domNodes.$color.text(vehicle.vcolor);
    domNodes.$colorType.text(vehicle.vtipoColor);

    var priceAreaText = function priceAreaText() {
      switch (_getCurrentArea()) {
        case 'peninsula':
          return 'Pen./Bal.';
        case 'baleares':
          return 'Pen./Bal.';
        case 'canarias':
          return 'Canarias';
        default:
          return 'Pen./Bal.';
      }
    };

    domNodes.$priceArea.text(priceAreaText());

    var finalPrices = _setPrices(prices.precioMostrar, prices.precioOferta);
    domNodes.$pvpPrice.text('' + finalPrices.pvp);
    domNodes.$offerPrice.text('' + finalPrices.offer);
    var legalpriceObj = legal.getPriceLegal(vehicleData.dealersVehicles[0]);
    var $domLegalPrice = $('<p>*' + legalpriceObj.price + '</p>\n      <p>**' + legalpriceObj.offer + ' <br>' + legalpriceObj.registration + ' ' + legalpriceObj.moreInfo + ' ' + legalpriceObj.images + ' </p>');
    domNodes.$legalNotes.append($domLegalPrice);
  };

  var _setPrices = function _setPrices(pvp, offer) {
    return {
      pvp: utils.formatPrice(pvp),
      offer: utils.formatPrice(offer)
    };
  };

  var _setLegalNote = function _setLegalNote(content) {
    var $legalNote = $('<p/>').html(content);
    domNodes.$legalNotes.append($legalNote);
  };

  var _makeFigure = function _makeFigure(bgColor, imagesObj) {
    var cbHost = 'https://configurador.nissan.es/',
        $figure = $('<figure/>'),
        $imgShadows = $('<img/>'),
        $imgLights = $('<img/>'),
        $imgBase = $('<img/>');

    $imgShadows.attr({
      src: '' + cbHost + imagesObj.shadows
    }).css('background-color', bgColor);

    $imgLights.attr({
      src: '' + cbHost + imagesObj.lights
    });
    $imgBase.attr({
      src: '' + cbHost + imagesObj.base
    });

    $figure.append($imgShadows, $imgLights, $imgBase);

    if (imagesObj.hasOwnProperty('color2')) {
      var $imgBitone = $('<img/>');
      $imgBitone.attr({
        src: '' + cbHost + imagesObj.color2
      });
      $figure.append($imgBitone);
    }
    return $figure;
  };

  var _displayImages = function _displayImages() {
    var vehicle = _getCurrentVehicle(),
        bgColor = vehicle.vhexadecimal,
        images3l4f = vehicleImg.getImgUrls(vehicle, '3l4f', '507x321'),
        images3l4t = vehicleImg.getImgUrls(vehicle, '3l4t', '507x321'),
        imagesl = vehicleImg.getImgUrls(vehicle, 'l', '507x321');
    var $imgFront = _makeFigure(bgColor, images3l4f);
    var $imgBack = _makeFigure(bgColor, images3l4t);
    _vehiclesViews($imgFront, $imgBack);

    var $vehiclePce = _makeFigure(bgColor, imagesl);
    $vehiclePce.addClass('vehicleImage');
    $('.js-pce-vehicle-image').append($vehiclePce);
  };

  var _vehiclesViews = function _vehiclesViews($front, $back) {
    var $viewContainer = $('.js-top-vehicle-image'),
        $buttons = $('.js-vehicle-view-btn');

    $viewContainer.append($front, $back);
    var visible = $front;
    var hidden = $back;
    hidden.addClass('hidden');

    $buttons.on('click', function () {
      var toHide = visible,
          toShow = hidden;
      visible.addClass('hidden');
      hidden.removeClass('hidden');
      visible = toShow;
      hidden = toHide;
    });
  };

  var _displayPCE = function _displayPCE() {
    var vehicle = _getCurrentVehicle(),
        pce = new PCE({
      model: vehicle.vmodelo,
      isCommercial: 'false',
      isElectric: vehicle.vcombustible.startsWith('El'),
      modelcb: vehicle.vmodelo,
      codCom: vehicle.vcodcom17,
      homologacion: vehicle.vfaseHomologacion,
      performance: {
        acceleration: '' + vehicle.naceleracion,
        maxspeed: '' + vehicle.nvelocidad,
        power: vehicle.vpotencia,
        electricPower: vehicle.vpotenciaElect,
        body: vehicle.vcarroceria,
        torque: '' + vehicle.npar,
        cc: '' + vehicle.ncilindrada,
        fuel: vehicle.vcombustible,
        range: vehicle.vautonomia,
        mma: vehicle.vmma,
        payload: vehicle.vcargautil,
        cargoVol: vehicle.vvolumencarga,
        wheelbase: vehicle.vdistanciaejes,
        bodyMaxLength: '' + vehicle.ndistmaxcarro,
        turnRadius: vehicle.vradiogiro,
        doors: '' + vehicle.npuertas,
        seats: '' + vehicle.nplazas
      },
      consumptEmissions: {
        reglamentacion: vehicle.vreglamentacion,
        NEDCBT_CO2U: vehicle.nedcbt_co2u,
        NEDCBT_CO2EU: vehicle.nedcbt_co2eu,
        WLTP_FM: vehicle.wltp_fm,
        NEDC_CE: vehicle.nedc_ce,
        NEDC_CC: vehicle.nedc_cc,
        WLTP_ACU: vehicle.wltp_acu,
        NEDCBT_CO2CC: vehicle.nedcbt_co2cc,
        NEDC_ACC: vehicle.nedc_acc,
        NEDCBT_CU: vehicle.nedcbt_cu,
        NEDC_CU: vehicle.nedc_cu,
        WLTP_FB: vehicle.wltp_fb,
        WLTP_FA: vehicle.wltp_fa,
        vcodcom13: vehicle.vcodcom13,
        WLTP_CE: vehicle.wltp_ce,
        NEDC_CEU: vehicle.nedc_ceu,
        NEDCBT_ACC: vehicle.nedcbt_acc,
        NEDCBT_CC: vehicle.nedcbt_cc,
        NEDCBT_CE: vehicle.nedcbt_ce,
        homologacion: vehicle.vfaseHomologacion,
        WLTP_CO2A: vehicle.wltp_co2a,
        WLTP_CO2B: vehicle.wltp_co2b,
        WLTP_CO2M: vehicle.wltp_co2m,
        NEDC_CO2: vehicle.nedc_co2,
        NEDCBT_CEU: vehicle.nedcbt_ceu,
        WLTP_CO2EA: vehicle.wltp_co2ea,
        WLTP_ACC: vehicle.wltp_acc,
        WLTP_CC: vehicle.wltp_cc,
        WLTP_COCC: vehicle.wltp_cocc,
        WLTP_FEA: vehicle.wltp_fea
      }
    });
    _setLegalNote(pce.legalSimple);
  };

  var _init = function _init(area) {
    _setCurrentArea(area);
    console.log('vehicleData', vehicleData);
    // Pending: control response ok: false and errors
    // $.getJSON(`${sourceUrl}json_sample.json`, function(response) {
    var currentVehicle = vehicleData.dealersVehicles[0];
    _setCurrentVehicle(currentVehicle.vehicle);
    _setCurrentPrices(currentVehicle.prices);

    _displayGeneralData();
    _displayImages();

    _displayPCE();
    equipment.init(currentVehicle.vehicle.ngrado);

    _printTitle(currentVehicle.vehicle.vdisplayModelo);
    _addMetaDescription(area);
    _printBreadCrum(currentVehicle.vehicle.vdisplayModelo);

    $('.js-link-form-request').attr('href', currentVehicle.vehicle.vcodcom17 + '/peticion');

    // })
  };

  return {
    init: _init,
    setCurrentVehicle: _setCurrentVehicle,
    setCurrentPrices: _setCurrentPrices,
    setCurrentArea: _setCurrentArea,
    displayGeneralData: _displayGeneralData,
    displayImages: _displayImages,
    calculatePrices: _setPrices,
    printTitle: _printTitle,
    printBreadCrum: _printBreadCrum
  };
}();